<template>
    <div @click.prevent="calendarCellClicked" :key="loadComponent" :data-test="`calendar-cell-${event.start}`">
        <div class="calendar-cell" :class="{ expired: event.expired }" :data-test="`schedule-date-${event.schedule_date ? event.schedule_date.id : 'new'}`">
            <template v-if="event.rendering === 'background'">
                <span class="icon icon-dynamic-pricing" v-if="mergedConfig.dynamicPricingIcon"></span>
                <span class="icon icon-auto-restock" v-if="mergedConfig.autoRestockIcon"></span>
                <span class="event-title">{{ event.title }}</span>
            </template>
            <template v-else>
                <template v-if="hasErrors">
                    <i class="fal fa-exclamation-triangle text-danger"></i>
                </template>
                <template v-else>
                    {{ event.title }}
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        event: {
            required: true,
        },
        element: {
            required: true,
        },
        config: {},
        leadTime: {},
    },
    methods: {
        calendarCellClicked() {
            Bus.$emit('calendarCellClicked', {
                event: this.event,
                element: this.element,
                config: this.config,
                leadTime: this.leadTime,
            });
        },
    },
    computed: {
        mergedConfig() {
            return {
                dynamicPricingIcon: _.get(this.config, 'icons', _.get(this.config, 'dynamicPricingIcon', false)),
                autoRestockIcon: _.get(this.config, 'icons', _.get(this.config, 'autoRestockIcon', false)),
            };
        },
        hasErrors() {
            return _.get(this.event, 'errors', []).length && this.event.asset_type !== 'promo_bundle';
        },
    },
    watch: {
        event() {
            this.reloadComponent();
        },
        leadTimeDate() {
            this.reloadComponent();
        },
    },
};
</script>
